import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cb8307b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jiacu" }, "VIP", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.vipinfo.type > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "vipprice vip1",
        style: _normalizeStyle({ backgroundImage:'url('+_ctx.vipinfo.backgroundimg+')', color: _ctx.vipinfo.color })
      }, [
        _createElementVNode("p", {
          class: "vipprice-p",
          style: _normalizeStyle({ color: _ctx.vipinfo.color })
        }, [
          _createElementVNode("img", {
            class: "vipprice-p-img",
            src: _ctx.vipinfo.imgurl
          }, null, 8, _hoisted_1),
          (_ctx.vipinfo.type == 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.vipinfo.title), 1),
                _hoisted_3,
                _createTextVNode("会员价")
              ]))
            : _createCommentVNode("", true),
          (_ctx.vipinfo.type == 1)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                style: _normalizeStyle({ color: _ctx.vipinfo.color })
              }, _toDisplayString(_ctx.vipinfo.title) + "价", 5))
            : _createCommentVNode("", true),
          _createElementVNode("i", {
            class: "icon iconfont icon-a-Group14379",
            style: _normalizeStyle([{"margin-left":"5px"}, { color: _ctx.vipinfo.color }])
          }, null, 4),
          _createElementVNode("span", {
            style: _normalizeStyle([{ color: _ctx.vipinfo.color }, {"font-size":"16px","font-weight":"600"}])
          }, _toDisplayString(Math.round(_ctx.price * 0.8)), 5)
        ], 4)
      ], 4))
    : _createCommentVNode("", true)
}